import * as numeral from 'numeral';
import { includes, times, get, escapeRegExp } from 'lodash';

numeral.register('locale', 'fr', {
  delimiters: {
    thousands: ' ',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal: number => (number === 1 ? 'er' : 'ème'),
  currency: {
    symbol: '$',
  },
});

numeral.register('locale', 'es', {
  delimiters: {
    thousands: ',',
    decimal: '.',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  currency: {
    symbol: '$',
  },
});

// Jest specs are compiled with ts-jest, while webpack still is not.
// This is a stop-gap for including typescript loader in webpack.
const makeNumeral = typeof numeral === 'function' ? numeral : numeral.default;

const cleanThousandsDelimiters = string => (numeral.locale() === 'fr' ?
  string.replace(/\s/g, '').replace(/,/, '.') :
  string.replace(/,/g, ''));

const isParseable = (value) => {
  if (typeof value === 'number') return true;
  return !includes(['', null, undefined], value) && !isNaN(cleanThousandsDelimiters(value.toString()));
};

const isParseableEn = (value) => {
  if (typeof value === 'number') return true;
  return !includes(['', null, undefined], value) && !isNaN(value.toString().replace(/,/g, ''));
};

const parseEn = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  return isParseableEn(value) ?
    parseFloat(value.toString().replace(/,/g, '')) :
    defaultValue;
};

const parse = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  return isParseable(value) ?
    parseFloat(cleanThousandsDelimiters(value.toString())) :
    defaultValue;
};

const getDecimalDelimiter = () => get(numeral, `locales.${numeral.locale()}.delimiters.decimal`, '.');

const endsWithDecimalDelimiter = string =>
  new RegExp(`${escapeRegExp(getDecimalDelimiter())}$`).test(string);

const format = (value, { autoDecimal = false, decimalPlaces = 0 } = {}) => {
  let effectiveDecimalPlaces = decimalPlaces;
  if (autoDecimal) {
    const decimals = value.toString().split('.')[1];
    effectiveDecimalPlaces = decimals ? decimals.length : 0;
  }
  const formatString = `0,0.${times(effectiveDecimalPlaces, () => 0).join('')}`;
  return makeNumeral(value).format(formatString);
};

const parseAndFormat = (value, formatOptions) => format(parse(value), formatOptions);

export default {
  isParseable,
  isParseableEn,
  parse,
  parseEn,
  format,
  parseAndFormat,
  getDecimalDelimiter,
  endsWithDecimalDelimiter,
};
